import $ from 'jquery';
import { theme_breakpoints } from 'drupalSettings';

const breakpoints = {
  'min': {},
  'max': {},
};

Object.keys(theme_breakpoints).forEach((key) => {
  breakpoints.min['mb'] = window.matchMedia('(min-width: 0px)');
  breakpoints.min[key] = window.matchMedia(`(min-width: ${theme_breakpoints[key]}px)`);
  breakpoints.max[key] = window.matchMedia(`(max-width: ${theme_breakpoints[key] - 1}px)`);
})

export const keys = Object.keys(theme_breakpoints);

export default breakpoints
